import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRSobCompetitorsComments = createSelector(
  [selectQbrState],
  ({ selectedDocument, documentSettings: { offerings } }) => {
    if (!selectedDocument) {
      return []
    }
    return offerings.reduce((acc, offering) => {
      const comment = selectedDocument?.SobCompetitorsComments?.[offering]
      if (comment) {
        return {
          ...acc,
          [offering]: comment,
        }
      }

      return acc
    }, {})
  }
)
